/**
 * Created by M.J. van der Werf <vanderwerf@bluehorizon.nl> on 4-9-17.
 */
import TextAreaQuestion from "../../presentation/TextArea/TextAreaQuestion";
import {Text} from "../Text/TextQuestion";

export default Text(TextAreaQuestion);
